module["exports"] = [
  "?#? #?#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/postcode.js
// module id = 1092
// module chunks = 0